var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHtlPaymentFilled = function SvgHtlPaymentFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.571 12.167h-.572V2h.572a1.418 1.418 0 0 1 1.417 1.417v7.334a1.418 1.418 0 0 1-1.417 1.416Zm-1.571 0H7.53a.5.5 0 0 1 0-1 1.858 1.858 0 0 0 1.367-2.142c-.136-.684-.611-1.194-.946-1.194-.13 0-.3.072-.38.412a.5.5 0 0 1-1 0V3.416a1.418 1.418 0 0 1 1.417-1.417H11V12.167Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.49 9.375A5.982 5.982 0 0 1 8.24 8c.733 0 1.069.917.917 1.375-.4 1.2-2.081 3.009-1.714 4.109"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.443 13.985a.5.5 0 0 1-.474-.342c-.308-.923.35-2.006.985-3.054.287-.433.531-.892.729-1.372a.737.737 0 0 0-.138-.537.355.355 0 0 0-.3-.179 5.574 5.574 0 0 0-2.443 1.265.5.5 0 0 1-.625-.781A6.433 6.433 0 0 1 8.24 7.5a1.356 1.356 0 0 1 1.116.592 1.686 1.686 0 0 1 .276 1.438 8.52 8.52 0 0 1-.823 1.574c-.469.773-1.053 1.735-.892 2.219a.5.5 0 0 1-.474.658v.004Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.832 13.985a.5.5 0 0 1-.464-.314 24.733 24.733 0 0 1-1.074-3.437c-.385-1.7-.375-2.82.03-3.428.855-1.283 3.38-2.354 4.47-2.509a.5.5 0 1 1 .141.99 7.246 7.246 0 0 0-3.78 2.074c-.085.128-.33.7.113 2.652A24.033 24.033 0 0 0 4.295 13.3a.5.5 0 0 1-.463.686Z"
  })));
};
export default SvgHtlPaymentFilled;